import React from "react";
import { SkeletonText } from "./SkeletonText";
import { 
  SkeletonSize, 
  SkeletonWidth, 
  SkeletonSpacing, 
  SKELETON_SPACING_CLASSES 
} from "@/common/skeleton.common";
import { cn } from "@/lib/utils";

interface TextLine {
  size?: SkeletonSize;
  width?: SkeletonWidth;
}

interface SkeletonTextGroupProps {
  lines: TextLine[];
  spacing?: SkeletonSpacing;
  className?: string;
}

export const SkeletonTextGroup = React.memo<SkeletonTextGroupProps>(({ 
  lines, 
  spacing = "md",
  className 
}) => {
  const spacingClass = SKELETON_SPACING_CLASSES[spacing];

  return (
    <div className={cn(spacingClass, className)} aria-hidden="true">
      {lines.map((line, index) => (
        <SkeletonText
          key={index}
          size={line.size}
          width={line.width}
        />
      ))}
    </div>
  );
});

SkeletonTextGroup.displayName = "SkeletonTextGroup"; 